import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import BannerNewsItem from "../../components/BannerNewsItem";
import { getContent } from "../../utils/main";
import * as Icon from "react-bootstrap-icons";
import ContentLoader from "react-content-loader";
import { useSearchParams } from 'react-router-dom';

const Posts = () => {
  const content = useSelector((state) => state.mainSlice.content);
  const lang = useSelector((state) => state.mainSlice.lang);
  const [buttonShow, setButtonShow] = useState(true);
  const [count, setCount] = useState(0);
  const size = 100;
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [word, setWord] = useState("");
  const [date, setDate] = useState("");
  const [category, setCategory] = useState("");
  const alar = "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa";
  const [searchParams, setSearchParams] = useSearchParams();

  const _fetchPosts = () => {
    setIsLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/posts/all-posts/?size=${size}&page=${page}&word=${word}&category=${category}&date=${date}`
      )
      .then((res) => {
        if (count === 0) setCount(res.data.count);
        setPosts([...res.data.results]);
        document.body.scrollTop = 0; 
        document.documentElement.scrollTop = 0;
      })
      .catch((res) => {
        if (res.response.status === 404) {
          setButtonShow(false);
        }
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    _fetchPosts();
    if (searchParams.get('page') !== null){
      setPage(parseInt(searchParams.get('page')));
      setSearchParams({["page"]: parseInt(searchParams.get('page'))});
    } else {
      setPage(1);
      setSearchParams({["page"]: 1});
    }
  }, [page]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/posts/categories/`)
      .then((res) => {
        setCategories(res.data);
      })
      .then(() => {
        setCategoriesLoading(false);
      });
  }, []);

  const _handleSearch = () => {
    setButtonShow(true);
    setPage(1);
    _fetchPosts();
  };
  return (
    <div className="posts-wrapper py-5">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4
              className=""
              style={{
                textAlign: "left !important",
                fontSize: "24px",
                fontWeight: "600",
                marginBottom: "20px",
              }}
            >
              {getContent(content, "News", lang)}
            </h4>
          </div>
        </div>
        <div className="row mobile-reverse">
          <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
            {
              isLoading === true ? (
                <div>
                  <ContentLoader viewBox="0 0 306 45" className="bra5">
                    <rect x="0" y="0" rx="0" ry="0" width="80%" height="10" />
                    <rect x="0" y="13" rx="0" ry="0" width="20%" height="8" />
                    <rect x="0" y="24" rx="0" ry="0" width="100%" height="14" />
                  </ContentLoader>
                  <ContentLoader viewBox="0 0 306 45" className="bra5">
                    <rect x="0" y="0" rx="0" ry="0" width="80%" height="10" />
                    <rect x="0" y="13" rx="0" ry="0" width="20%" height="8" />
                    <rect x="0" y="24" rx="0" ry="0" width="100%" height="14" />
                  </ContentLoader>
                </div>
              ) : (
                posts.length === 0
              ? ""
              : posts.map((post, index) =>
                  lang === "en" ? (
                    post.name_en !== null && post.name_en !== "" ? (
                      <BannerNewsItem post={post} type="posts" key={post.id} />
                    ) : (
                      ""
                    )
                  ) : lang === "ru" ? (
                    post.name_ru !== null && post.name_ru !== "" ? (
                      <BannerNewsItem post={post} type="posts" key={post.id} />
                    ) : (
                      ""
                    )
                  ) : (
                    <BannerNewsItem post={post} type="posts" key={post.id} />
                  )
                )
              )
            }
            {
              posts.length === 0
              ? ""
              : alar.substring(0,(count % 100 === 0 ? count/100 : count/100 + 1)).split("").map(
                (a, index) => <button onClick={() => {setPage(index+1); setSearchParams({["page"]: index+1})}} className={`pagination-btn ${index+1 === page ? 'active' : ''}`}>
                  {index+1}
                  </button>
              )
            }
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div className="mb-4 floating-label">
              <input
                type="text"
                name="word"
                className="form-control"
                placeholder=" "
                required
                onChange={(e) => {
                  setWord(e.target.value);
                }}
              />
              <label htmlFor="text">
                {getContent(content, "Search", lang)} *
              </label>
            </div>
            <div className="mb-4 floating-label">
              <select
                name="category"
                className="form-control"
                required
                onChange={(e) => {
                  setCategory(e.target.value);
                }}
              >
                <option value="">
                  {getContent(content, "No option", lang)}
                </option>
                {categoriesLoading === true ? (
                  <option value="loading">Loading...</option>
                ) : (
                  categories.map((category) => (
                    <option value={category.slug} key={category.id}>
                      {lang === "en"
                        ? category.name_en
                        : lang === "ru"
                        ? category.name_ru
                        : category.name_tm}
                    </option>
                  ))
                )}
              </select>
              <label htmlFor="category">
                {getContent(content, "Category", lang)} *
              </label>
            </div>
            <div className="mb-3 floating-label">
              <input
                type="date"
                name="date"
                className="form-control"
                placeholder=" "
                required
                onChange={(e) => {
                  setDate(e.target.value);
                }}
              />
              <label htmlFor="date">
                {getContent(content, "Date", lang)} *
              </label>
            </div>
            <div className="mb-4">
              <button
                className="black-btn clear-btn px-5 w-100"
                onClick={() => _handleSearch()}
              >
                {getContent(content, "Search", lang)} &nbsp; <Icon.Search />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Posts;
